import { render, staticRenderFns } from "./role-menu-permission-modal.vue?vue&type=template&id=f67ddfc8&"
import script from "./role-menu-permission-modal.vue?vue&type=script&lang=js&"
export * from "./role-menu-permission-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports